var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7071 0.293031C23.5196 0.10556 23.2653 0.000244141 23.0001 0.000244141C22.735 0.000244141 22.4807 0.10556 22.2931 0.293031L12.0001 10.586L1.70715 0.293031C1.51962 0.10556 1.26531 0.000244141 1.00015 0.000244141C0.734981 0.000244141 0.480673 0.10556 0.293145 0.293031C0.105674 0.480558 0.000358582 0.734866 0.000358582 1.00003C0.000358582 1.26519 0.105674 1.5195 0.293145 1.70703L10.5861 12L0.293145 22.293C0.105674 22.4806 0.000358582 22.7349 0.000358582 23C0.000358582 23.2652 0.105674 23.5195 0.293145 23.707C0.480673 23.8945 0.734981 23.9998 1.00015 23.9998C1.26531 23.9998 1.51962 23.8945 1.70715 23.707L12.0001 13.414L22.2931 23.707C22.4807 23.8945 22.735 23.9998 23.0001 23.9998C23.2653 23.9998 23.5196 23.8945 23.7071 23.707C23.8946 23.5195 23.9999 23.2652 23.9999 23C23.9999 22.7349 23.8946 22.4806 23.7071 22.293L13.4141 12L23.7071 1.70703C23.8946 1.5195 23.9999 1.26519 23.9999 1.00003C23.9999 0.734866 23.8946 0.480558 23.7071 0.293031Z",
    fill: "#B0B0B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModalIcon);
export default __webpack_public_path__ + "static/media/closeModalIcon.01606d1fa56db3b738eb105d40dfaa50.svg";
export { ForwardRef as ReactComponent };